import { render, staticRenderFns } from "./TalentsTable.vue?vue&type=template&id=16117c2f&"
import script from "./TalentsTable.vue?vue&type=script&lang=js&"
export * from "./TalentsTable.vue?vue&type=script&lang=js&"
import style0 from "./TalentsTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports